'use client';

import { c as _c } from "react/compiler-runtime";
import { Heart, HeartSolid } from '@byway/icons';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import { CenteredModal } from '~/components/CenteredModal';
import { SAVE_TRIP_TRACKING_ID } from '~/components/Common/SaveButton/src/useSaveTrip';
import { Divider } from '~/components/Divider';
import { OverlayDrawer } from '~/components/Drawer';
import { TRPC_SETTINGS } from '~/constants/trpc';
import { useIsDesktop } from '~/hooks/useIsDesktop';
import { useTripSave } from '~/hooks/useTripSave';
import { api } from '~/libs/api';
import { trackEvent } from '~/utils';
import { deriveTripEditability } from '../lib/tripEditability';
import styles from './SaveTripButton.module.css';
type SaveTripButtonProps = {
  tripId: string | null | undefined;
  className: string;
  size: 'small' | 'large';
  iconVariant?: 'default' | 'overviewIntro';
};
export const SaveTripButton = t0 => {
  const $ = _c(60);
  const {
    tripId,
    className,
    size,
    iconVariant: t1
  } = t0;
  const iconVariant = t1 === undefined ? "default" : t1;
  const t = useTranslations("journey");
  const tAccount = useTranslations("account");
  const {
    isTripSaved,
    isPending,
    isLoginOpen,
    setIsLoginOpen,
    handleSave,
    handleLogin
  } = useTripSave(tripId);
  const isDesktop = useIsDesktop();
  const iconSize = iconVariant === "overviewIntro" ? "small" : size;
  let t2;
  if ($[0] !== tAccount) {
    t2 = tAccount("save_defer");
    $[0] = tAccount;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const heading = t2;
  let t3;
  if ($[2] !== setIsLoginOpen) {
    t3 = () => setIsLoginOpen(false);
    $[2] = setIsLoginOpen;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const close = t3;
  const t4 = tripId ?? "";
  let t5;
  if ($[4] !== t4) {
    t5 = {
      tripId: t4
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = !!tripId;
  let t7;
  if ($[6] !== t6) {
    t7 = {
      ...TRPC_SETTINGS.QUERY_NO_REFETCH,
      enabled: t6,
      keepPreviousData: true
    };
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const {
    data: overviewData
  } = api.trip.getOverview.useQuery(t5, t7);
  if (deriveTripEditability(overviewData).isBooked) {
    return null;
  }
  let t8;
  if ($[8] !== tAccount) {
    t8 = tAccount("defer");
    $[8] = tAccount;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== close || $[11] !== t8) {
    t9 = <Button onPress={close} size="fullWidth" variant="tertiary" isPillShape={true} dataTestId="SaveTripLoginDefer">{t8}</Button>;
    $[10] = close;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== tAccount) {
    t10 = tAccount("log_in");
    $[13] = tAccount;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== handleLogin || $[16] !== t10) {
    t11 = <Button onPress={handleLogin} size="fullWidth" isPillShape={true} dataTestId="SaveTripLoginConfirm">{t10}</Button>;
    $[15] = handleLogin;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t9) {
    t12 = <div className={styles.actions}>{t9}{t11}</div>;
    $[18] = t11;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const actions = t12;
  const t13 = isDesktop && styles.bodyModal;
  let t14;
  if ($[21] !== t13) {
    t14 = clsx(styles.body, t13);
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== heading) {
    t15 = <h2 className={styles.heading}>{heading}</h2>;
    $[23] = heading;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== tAccount) {
    t16 = tAccount("login_prompt_save");
    $[25] = tAccount;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t16) {
    t17 = <p className={styles.text}>{t16}</p>;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== actions || $[30] !== isDesktop) {
    t18 = isDesktop ? <div className={styles.footerModal}><Divider variant="horizontal" />{actions}</div> : actions;
    $[29] = actions;
    $[30] = isDesktop;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t14 || $[33] !== t15 || $[34] !== t17 || $[35] !== t18) {
    t19 = <div className={t14}>{t15}{t17}{t18}</div>;
    $[32] = t14;
    $[33] = t15;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  const body = t19;
  let t20;
  if ($[37] !== t) {
    t20 = t("overview_save_trip");
    $[37] = t;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  const t21 = isPending || undefined;
  const t22 = isPending || undefined;
  let t23;
  if ($[39] !== handleSave) {
    t23 = () => {
      trackEvent(SAVE_TRIP_TRACKING_ID, {
        event_category: "click",
        event_label: SAVE_TRIP_TRACKING_ID
      });
      handleSave();
    };
    $[39] = handleSave;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== iconSize || $[42] !== isTripSaved) {
    t24 = isTripSaved ? <HeartSolid decorative={true} isInline={true} size={iconSize} /> : <Heart decorative={true} isInline={true} size={iconSize} />;
    $[41] = iconSize;
    $[42] = isTripSaved;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== className || $[45] !== t20 || $[46] !== t21 || $[47] !== t22 || $[48] !== t23 || $[49] !== t24) {
    t25 = <button type="button" className={className} aria-label={t20} aria-disabled={t21} aria-busy={t22} onClick={t23}>{t24}</button>;
    $[44] = className;
    $[45] = t20;
    $[46] = t21;
    $[47] = t22;
    $[48] = t23;
    $[49] = t24;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== body || $[52] !== close || $[53] !== heading || $[54] !== isDesktop || $[55] !== isLoginOpen) {
    t26 = isDesktop ? <CenteredModal ariaLabel={heading} close={close} closeDataTestId="SaveTripLoginModalClose" dataTestId="SaveTripLoginModal" fitContent={true} isOpen={isLoginOpen} size="medium">{body}</CenteredModal> : <OverlayDrawer isOpen={isLoginOpen} close={close} ariaLabel={heading} dataTestId="SaveTripLoginDrawer">{body}</OverlayDrawer>;
    $[51] = body;
    $[52] = close;
    $[53] = heading;
    $[54] = isDesktop;
    $[55] = isLoginOpen;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t25 || $[58] !== t26) {
    t27 = <>{t25}{t26}</>;
    $[57] = t25;
    $[58] = t26;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  return t27;
};